// assets/video-autoplay.js
document.addEventListener('DOMContentLoaded', function () {
  try {
    const videos = document.querySelectorAll('.product__media video, .media video');
    if (!videos || videos.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(v => {
        v.muted = true;
        v.loop = true;
        try { v.play(); } catch(e) {}
      });
      return;
    }

    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(()=>{/* autoplay blocked */});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.5 });

    videos.forEach(v => {
      v.muted = true;
      v.loop = true;
      obs.observe(v);
    });
  } catch (err) {
    // safe fail — do not break other scripts
    console.error('video-autoplay.js error', err);
  }
});
